<template>
  <div>
    <div class="w-full mb-8">
      <button type="button"
        class="bg-tertiary hover:border-tertiary text-white py-2 px-2 text-sm border border-grey-lightest hover:border-transparent rounded mb-2 md:w-1/7 md:mt-1 sm:ml-2 sm:mt-2 md:mr-0 h-10"
        @click="downloadImages(true)">
        <loader v-if="loadingAllDownload" :fillColor="'white'"/>
        <span v-else>
          Download All <i class="fas fa-download"></i>
        </span>
      </button>
      <button type="button"
        class="bg-tertiary hover:border-tertiary text-white py-2 px-2 text-sm border border-grey-lightest hover:border-transparent rounded mb-2 md:w-1/7 md:mt-1 sm:ml-2 sm:mt-2 md:mr-0 h-10"
        @click="downloadImages(false)">
        <loader v-if="loadingSelectedDownload" :fillColor="'white'"/>
        <span v-else>
         Download Selected <i class="fas fa-download"></i>
        </span>
      </button>
    </div>
    <div class="w-full px-2">
      <transition-group class="flex flex-wrap -mx-2 gallery-container" name="list" tag="div">
        <div v-for="(card, i) in cards" :key="i + 0" :class="cardClass"
             class="bg-white" :data-index="i">
          <div class="flex flex-wrap -mx-2 text-sm mb-2" v-if="card.progress === undefined">
            <div class="title w-1/2 mb-2 px-2" v-if="card.caption" :title="card.caption">
              {{ limitedCaption(card.caption) }}
            </div>
            <div class="title w-1/2 mb-2 px-2" v-else>
              {{ type }} #{{ i + 1 }}
            </div>
            <div class="icons w-1/2 text-right px-2">
              <input type="checkbox" class="green" :id="`include${card.id}`" v-model="selectedCards" :value="card" />
              <label :for="`include${card.id}`"></label>
              <a v-if="card.url !== null" :href="card.url.original ? card.url.original : card.url" target="_blank"
                 download><i class="fas fa-download text-tertiary cursor-pointer mr-6 text-lg" title="Download"></i></a>
            </div>
          </div>
          <div class="flex flex-col bg-grey-lighter border p-2 text-center">
            <div class="img-preview w-full h-64 text-red-dark flex flex-wrap content-center justify-center"
                 v-if="card.url === null"
                 :title="feedProvider ? `File not received from ${feedProvider.name}` : 'Media not available'">
              <i class="fas fa-exclamation-triangle fa-3x"></i>
            </div>
            <div class="img-preview w-full h-64" v-else-if="card.url && card.url.large"
                 :style="{'background-image': `url('${card.url.large}')`}"></div>
            <div class="img-preview w-full h-64 text-tertiary flex flex-wrap content-center justify-center" v-else>
              <i class="fas fa-file fa-3x"></i>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import JSZip from 'jszip'
import SaveAs from 'file-saver'

export default {
  name: 'photo-gallery',
  props: {
    type: String,
    cardClass: String,
    cards: Array,
    feedProvider: Object
  },
  data () {
    return {
      selectedCards: [],
      loadingAllDownload: false,
      loadingSelectedDownload: false
    }
  },
  computed: {
    ...mapState(['currentProperty', 'selectedOffice'])
  },
  created () {
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    async downloadImages (allFlag) {
      if (this.loadingAllDownload) {
        return
      }
      if (this.loadingSelectedDownload) {
        return
      }
      if (allFlag) {
        this.loadingAllDownload = true
      } else {
        this.loadingSelectedDownload = true
      }
      let newZip = new JSZip()
      let cards = allFlag ? this.cards : this.selectedCards
      for (let i = 0; i < cards.length; i++) {
        if (cards[i]['url']['original']) {
          const response = await fetch(cards[i]['url']['original'])
          const blob = await response.blob()
          const extention = cards[i]['url']['original'].split('.').pop().toLowerCase()
          let fileName = cards[i].caption ? cards[i].caption + '.' + extention : 'image_' + i + '.' + extention
          newZip.file(fileName, blob)
        }
      }

      newZip.generateAsync({ type: 'blob' }).then(content => {
        SaveAs(content, 'photos.zip')
      })
      if (allFlag) {
        this.loadingAllDownload = false
      } else {
        this.loadingSelectedDownload = false
      }
    },
    limitedCaption (caption) {
      const maxLength = 13
      if (caption && typeof caption === 'string') {
        if (caption.length <= maxLength) {
          return caption
        } else {
          return caption.substring(0, maxLength) + '....'
        }
      }
      return caption
    }
  }
}
</script>

<style type="scss" scoped>
.img-preview {
  background: no-repeat center / contain;
}

.draggable-tile {
  user-select: none;
}
</style>
